"use client";var s="@sainsburys-tech/icons",e="3.7.0";export{s as name,e as version};
